import Box from '@mui/joy/Box'
import { TemplateLibraryItem } from './TemplateLibraryItem'

export const TemplateLibraryList = ({
    templates,
    selected,
    onItemSelected,
    onItemClick,
}) =>
    templates.map((template) => (
        <TemplateLibraryItem
            key={template.id}
            selected={template.id in selected}
            template={template}
            onSelect={onItemSelected}
            onClick={onItemClick}
        />
    ))
